import { z } from 'zod';

/**
 * Por que o cliente cancela um voucher. Vocabulário fechado, compartilhado entre
 * o modal de cancelamento (web-chat), o BFF e a chamada Apollo de cancelamento —
 * uma única definição em vez de o literal string espalhado.
 *
 * MISTAKE = reserva feita por engano; CANCELED = viagem cancelada; RESCHEDULED =
 * viagem remarcada; OTHER = motivo livre (o `name` carrega o texto exibido).
 */
export const VoucherCancelMotiveCodeSchema = z.enum([
  'MISTAKE',
  'CANCELED',
  'RESCHEDULED',
  'OTHER',
]);
export type VoucherCancelMotiveCode = z.infer<typeof VoucherCancelMotiveCodeSchema>;

/**
 * O motivo completo enviado no corpo de POST /vouchers/:voucherId/cancel:
 * `code` é o enum canônico; `name` é o rótulo humano (pt-BR) do motivo, sempre
 * não-vazio para que o justification chegue populado ao provedor.
 */
export const VoucherCancelMotiveSchema = z.object({
  code: VoucherCancelMotiveCodeSchema,
  name: z.string().min(1),
});
export type VoucherCancelMotive = z.infer<typeof VoucherCancelMotiveSchema>;
